import React from "react";
import { Box, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function Footer() {
  return <Box component="footer" sx={{ mt: "auto", px: { xs: 2, md: 3.5 }, py: 2, borderTop: "1px solid", borderColor: "divider" }}>
    <Stack direction={{ xs: "column", sm: "row" }} gap={1} alignItems={{ sm: "center" }} justifyContent="space-between">
      <Typography variant="caption" color="text.secondary">&copy; {new Date().getFullYear()} ShopKaBot</Typography>
      <Stack direction="row" gap={2} flexWrap="wrap">{[{ label: "Privacy", path: "/privacy-policy" }, { label: "Terms", path: "/terms-of-service" }, { label: "Contact", path: "/contact-us" }].map(item => <Link key={item.path} component={RouterLink} to={item.path} underline="hover" color="text.secondary" sx={{ fontSize: 12 }}>{item.label}</Link>)}</Stack>
    </Stack>
  </Box>;
}
